module.exports = __webpack_public_path__ + "static/media/down_blue.295500d0.svg";